import axios from 'axios';
import {
  KeywordGetRequest,
  KeywordGetResponse,
  KeywordParams,
  KeywordPostRequest,
  KeywordPostResponse,
  KeywordPutRequest,
  KeywordPutResponse,
} from '../model/keywordModel';

export const KeywordApi = {
  post: (data: KeywordPostRequest) => {
    return axios.post<KeywordPostResponse>('/api/keywords', data);
  },
  put: (params: KeywordParams, data: KeywordPutRequest) => {
    return axios.put<KeywordPutResponse>(`/api/keywords/${params.id}`, data);
  },
  getOne: (params: KeywordParams) => {
    return axios.get<KeywordGetResponse>(`/api/keywords/${params.id}`);
  },
  getAll: (params: KeywordGetRequest) => {
    return axios.get<KeywordGetResponse[]>('/api/keywords', {
      params: params,
    });
  },
};
